import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/shared/modal'
import SpaceMan from 'assets/images/space-man.png'

const MessageSpaceOwnerSuccess = ({
  children,
  header,
  message = 'Please check your inbox for a confirmation email. You may also find your message in your dashboard.',
}) => {
  return (
    <Modal
      onClose={() => location.reload()}
      className="modal-container bg-white w-11/12 md:max-w-2xl mx-auto rounded shadow-lg z-20"
    >
      <div className="modal-body my-5">
        <h2 className="text-xl">{header}</h2>
        <div className="flex">
          <div className="w-3/5">
            {children}
            <p className="my-10 max-w-md">{message}</p>
            <a
              href="/client"
              className="flex whitespace-no-wrap items-center text-center justify-center btn btn-primary w-full font-bold py-3 text-sm uppercase"
            >
              TAKE ME TO THE DASHBOARD
            </a>
          </div>
          <div className="w-2/5">
            <img alt="space man" src={SpaceMan} className="m-auto" />
          </div>
        </div>
      </div>
    </Modal>
  )
}

MessageSpaceOwnerSuccess.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.string,
  message: PropTypes.string,
  spaces: PropTypes.array,
}

export default MessageSpaceOwnerSuccess
